import {
    FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE, FETCH_USERS_COUNT_REQUEST, FETCH_USERS_COUNT_SUCCESS, FETCH_USERS_COUNT_FAILURE
} from "../actions/userActions";

const initialState = {
    usersList: [],
    totalCount: 0,
    isLoading: false,
    countLoading:false,
    error: null
};

export const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USERS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_USERS_SUCCESS:
            return { ...state, usersList: action.payload, isLoading: false };

        case FETCH_USERS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_USERS_COUNT_REQUEST:
            return { ...state, countLoading: true };

        case FETCH_USERS_COUNT_SUCCESS:
            return { ...state, totalCount: action.payload, countLoading: false };

        case FETCH_USERS_COUNT_FAILURE:
            return { ...state, error: action.payload, countLoading: false };

        default:
            return state;
    }
};
